import PptxGenJS from 'pptxgenjs';
import {
  addCoverSlide,
  addOverviewSlide,
  addEmissionsSlide,
  addCo2ePeriodSlide,
  addCo2eDetailSlide,
  addOperationalSlide,
  CoverSlideData,
  OverviewSlideData,
  EmissionsSlideData,
  Co2ePeriodSlideData,
  Co2eDetailSlideData,
  OperationalSlideData,
} from './slideBuilders';

export interface CpiPptExportData {
  cover: CoverSlideData;
  overview: OverviewSlideData;
  emissions: EmissionsSlideData;
  co2ePeriod: Co2ePeriodSlideData;
  co2eDetail: Co2eDetailSlideData;
  operational: OperationalSlideData;
}

export async function exportCpiToPpt(data: CpiPptExportData): Promise<void> {
  const pptx = new PptxGenJS();
  pptx.layout = 'LAYOUT_16x9';
  pptx.author = 'Loginex';
  pptx.title = `Klantrapportage ${data.cover.clientName}`;
  pptx.subject = 'CPI Carbon Emissions Report';

  await addCoverSlide(pptx, data.cover);
  addOverviewSlide(pptx, data.overview);
  addEmissionsSlide(pptx, data.emissions);
  addCo2ePeriodSlide(pptx, data.co2ePeriod);
  addCo2eDetailSlide(pptx, data.co2eDetail);
  addOperationalSlide(pptx, data.operational);

  const safeClientName = data.cover.clientName.replace(/[^a-zA-Z0-9-_]/g, '_');
  const filename = `CPI_Klantrapportage_${safeClientName}_${data.cover.startDate}_${data.cover.endDate}.pptx`;

  await pptx.writeFile({ fileName: filename });
}
